/* ==========================================================================
 *  Slide Down Up
 * ======================================================================= */
function fn_parts_slide_down_up(){
	if ($('.slideDownUp').length){
        $(".slideDownUp").bind('click', function() {
	        $(this).closest('.js-slide-wrapper').find('.content').toggleClass('active');
	    });
	}
}